module.exports = __webpack_public_path__ + "img/block7-card2.05b47064.svg";